import createTable from './CompanyDetailsTable';

export default createTable({
  namePrefix: 'harvcoTags',
  tableName: 'HarvCo Tags',
  columns: [{ field: 'tag' }],
});
